module.exports = "<svg id=\"618e8f4c-030e-49eb-9647-61b4e6016855\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 29\"><title>ig-01</title><rect width=\"29\" height=\"29\" rx=\"6.72\" ry=\"6.72\"></rect><circle cx=\"15.27\" cy=\"14.5\" r=\"5.44\" class=\"ig-phil\"></circle><circle cx=\"24.33\" cy=\"5.59\" r=\"1.94\" class=\"ig-dot\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ig.svg
// module id = 568
// module chunks = 1